const adjustColorBrightness = (color: string, amount: number) => {
  const hex = color.slice(1);
  const num = parseInt(hex, 16);

  let r = (num >> 16) + amount;
  // biome-ignore lint/style/useBlockStatements: legacy code - style/useBlockStatements
  if (r > 255) r = 255;
  // biome-ignore lint/style/useBlockStatements: legacy code - style/useBlockStatements
  else if (r < 0) r = 0;

  let g = ((num >> 8) & 0x00ff) + amount;
  // biome-ignore lint/style/useBlockStatements: legacy code - style/useBlockStatements
  if (g > 255) g = 255;
  // biome-ignore lint/style/useBlockStatements: legacy code - style/useBlockStatements
  else if (g < 0) g = 0;

  let b = (num & 0x0000ff) + amount;
  // biome-ignore lint/style/useBlockStatements: legacy code - style/useBlockStatements
  if (b > 255) b = 255;
  // biome-ignore lint/style/useBlockStatements: legacy code - style/useBlockStatements
  else if (b < 0) b = 0;

  return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, '0')}`;
};

export default adjustColorBrightness;
